<template>
  <div id="nb-global-preloader">
    <div id="ctn-preloader" class="ctn-preloader">
      <div class="round_spinner">
        <div class="spinner"></div>
        <div class="text">
          <svg-icon icon-class="logo-sp365-dark" style="width: 130px" width="130" class="sing-up-input-icon" />
        </div>
      </div>
      <div class="txt-loading">
        <span data-text-preloader="C" class="letters-loading">C</span>
        <span data-text-preloader="A" class="letters-loading">A</span>
        <span data-text-preloader="S" class="letters-loading">S</span>
        <span data-text-preloader="P" class="letters-loading">P</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderSupport',
}
</script>